import React from "react";
import { Link } from "gatsby";
import styles from "./articleSquare.module.css";
import heroImage from "../images/Prosty-CRM-online-dla-malych-firm.jpg";

const ArticleSquare = ({ title, link }) => {
  return (
    <div className={styles.wrapper}>
      <Link
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${heroImage})`
        }}
        className={styles.block}
        to={link}
      >
        {title}
      </Link>
    </div>
  );
};

export default ArticleSquare;
